import type { FaireProductEntity } from "../../entity_types/product";

export const p_t3pwpv88g3: FaireProductEntity = {
  token: "p_t3pwpv88g3",
  type: "product",
  name: "Blur Focus Putty  Single Color Case Pack",
  brandToken: "b_vw97v1k7ax",
  brandName: "Speks",
  imageUrl:
    "https://cdn.faire.com/fastly/3862e7dcbc9e6480ddc1b18e776e2f17dc9f2a4dfb26be1e1847ceca1188d5b1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a2175136590d84f1c935b53489e368b379ee62c91479a26367deb4954b32c78b.jpeg",
    "https://cdn.faire.com/fastly/190ed71f57e699ba572eb8ddc00cfa9afc36a88a1d8c913dce3fdaf5ae2a87ad.jpeg",
    "https://cdn.faire.com/fastly/e7395c65225fd6189de5eb16030c649edc15e4525087f01fe0510be03af2ed18.jpeg",
    "https://cdn.faire.com/fastly/2fbc84a7b983495791694a5df7c2e5e3852129eb30007abde51922066185cdff.jpeg",
    "https://cdn.faire.com/fastly/b5751b499e98b41b524ab9ac4dad6a0db8371b0cc7c3f99c0bc1032152153451.jpeg",
  ],
  priceDollars: 6.5,
  description:
    "Light, smooth and airy, Blur is the softest and silkiest putty on the market. This stretchable, squeezable putty won’t dry out and doesn’t make a sticky mess. Each color comes in a frosted container.\n\nUnit MSRP: $12.95\nPackaging size: 2.87 × 2.87 × 1.46\n",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:45.936Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
